/* istanbul ignore file */
// @mui
import Box from '@mui/material/Box';

const LoginIllustration = ({ ...other }) => {
  return (
    <Box {...other}>
      <svg width="364" height="359" viewBox="0 0 364 359" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M28.452 278.023 53.144 139.46h109.685l23.599 138.563H28.452z" fill="#637381" />
        <path
          d="M82.385 139.945c-.303-13.832 10.738-25.298 24.57-25.54 13.832-.304 25.298 10.738 25.541 24.57v.91"
          stroke="#000"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M185.579 108.52c-.364-17.108 13.286-31.304 30.394-31.668 17.108-.364 31.304 13.286 31.668 30.394v1.152"
          stroke="#338377"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M132.739 201.947 82.386 277.78h37.674l12.679-75.833z" fill="#000" />
        <path d="m118.846 279.843 30.576-171.505h135.711l29.241 171.505H118.846z" fill="#5EB1A8" />
        <path
          d="M340.098 336.08h-86.39l-40.646-41.556v-85.48h127.036V336.08z"
          fill="#fff"
          stroke="#000"
          strokeWidth="1.904"
          strokeMiterlimit="10"
        />
        <path d="m213.061 209.044-21.476 70.677h21.476" fill="#338377" />
        <path
          d="m284.224 248.114 2.972 8.069c.668 1.941 2.548 3.336 4.732 3.458l8.676.485c2.912.121 5.217 2.669 5.096 5.521a5.866 5.866 0 0 1-1.942 3.943l-6.794 5.399c-1.638 1.274-2.306 3.458-1.82 5.521l2.305 8.311c.789 2.791-.91 5.764-3.701 6.492-1.516.364-2.972.121-4.246-.668l-7.28-4.732c-1.76-1.152-4.065-1.152-5.764 0l-7.28 4.732c-2.426 1.638-5.763.91-7.401-1.516-.789-1.274-1.031-2.912-.667-4.247l2.305-8.311a5.08 5.08 0 0 0-1.82-5.521l-6.795-5.399c-2.305-1.82-2.669-5.218-.788-7.523.91-1.153 2.426-1.941 3.943-1.941l8.675-.486c2.063-.121 3.944-1.516 4.732-3.458l2.973-8.068c1.153-2.67 4.186-4.065 6.916-2.912 1.335.546 2.487 1.577 2.973 2.851z"
          fill="#262626"
        />
        <path
          d="M220.887 45.912c.304 9.1-7.401 16.926-16.076 19.292-8.736 2.366-18.079.182-26.451-3.276-8.311-3.458-16.198-8.19-24.631-11.345-8.432-3.154-18.078-4.55-26.511-1.274-8.857 3.458-15.227 11.891-17.897 21.052-2.669 9.16-2.002 18.988-.182 28.27"
          stroke="#C4CDD5"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeDasharray="4 4"
        />
        <path
          d="M236.661 35.113c1.638-.364 3.154-1.031 4.61-2.002a20.796 20.796 0 0 0-4.61-2.002c-1.638-.485-2.973-1.699-3.458-3.458-.364-1.638-1.032-3.154-2.002-4.61a20.755 20.755 0 0 0-2.002 4.61c-.486 1.638-1.699 2.973-3.458 3.458-1.638.364-3.276 1.032-4.672 2.002a20.092 20.092 0 0 0 4.672 2.002c1.638.486 2.972 1.699 3.458 3.458.364 1.638 1.031 3.155 2.002 4.61a20.848 20.848 0 0 0 2.002-4.61c.546-1.76 1.759-3.094 3.458-3.458z"
          fill="#000"
        />
      </svg>
    </Box>
  );
};

export default LoginIllustration;
